import { Lock, Zap } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { useNavigate } from "react-router-dom";
import { usePlan } from "@/hooks/usePlan";

interface ProGateProps {
  featureName: string;
  featureDescription: string;
  children: React.ReactNode;
}

export function ProGate({ featureName, featureDescription, children }: ProGateProps) {
  const { isPro, isLoading } = usePlan();
  const navigate = useNavigate();

  if (isLoading) {
    return (
      <div className="flex items-center justify-center py-24 text-muted-foreground text-sm">
        Loading...
      </div>
    );
  }

  if (!isPro) {
    return (
      <div className="flex items-center justify-center py-16 px-4">
        <Card className="max-w-md w-full p-8 text-center space-y-4">
          <div className="flex justify-center">
            <div className="p-3 bg-amber-100 rounded-full">
              <Lock className="h-6 w-6 text-amber-600" />
            </div>
          </div>
          <div>
            <h2 className="text-lg font-semibold">{featureName} is a Pro feature</h2>
            <p className="text-sm text-muted-foreground mt-1">{featureDescription}</p>
          </div>
          <Button
            className="bg-figgy-500 hover:bg-figgy-600 w-full"
            onClick={() => navigate("/dashboard/business-settings")}
          >
            <Zap className="mr-2 h-4 w-4" />
            Upgrade to Pro
          </Button>
        </Card>
      </div>
    );
  }

  return <>{children}</>;
}
